import { render } from "./DimensionsSection.vue?vue&type=template&id=1a76f1d9&scoped=true"
import script from "./DimensionsSection.vue?vue&type=script&lang=js"
export * from "./DimensionsSection.vue?vue&type=script&lang=js"

import "./DimensionsSection.vue?vue&type=style&index=0&id=1a76f1d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a76f1d9"]])

export default __exports__